module.exports = __webpack_public_path__ + "img/list.bba3498c.svg";